import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/rootReducer';
import { fetchCompanyList } from '@/features/company/companySlice';
import { Button, Form, FormItem, Input } from '@/components/atoms';
import { IMAGE_PATH_COMPANY_LICENSE, IMAGE_PATH_COMPANY_STAMP } from '@/constants/constant';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Col, Row } from 'antd';

const ManageCompanyInfoPage = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { user } = useSelector((state: RootState) => state.account);
  const { list } = useSelector((state: RootState) => state.company);

  const company = list.length ? list[0] : null;

  useEffect(() => {
    dispatch(fetchCompanyList());
  }, [dispatch]);

  const companyEditOnFinish = (values: any) => {
    console.log(values);
  };

  return (
    <div className="p-5">
      <h1 className="text-xl font-bold">사업자 정보</h1>

      {company === null && (
        <div className="flex justify-between">
          <div>소속된 회사가 없습니다.</div>
        </div>
      )}

      {company && (
        <Row gutter={[16, 16]}>
          <Col xs={24} lg={12} className="flex-col justify-start items-start">
            <h4 className="font-bold">사업자 등록증</h4>
            <LazyLoadImage
              className="max-w-full rounded"
              src={IMAGE_PATH_COMPANY_LICENSE(company.base.id, company.licenseFileName)}
              onClick={() => {
                console.log('aa');
              }}
            />

            <h4 className="font-bold mt-5">직인 파일</h4>

            <LazyLoadImage
              className="max-w-full rounded"
              src={IMAGE_PATH_COMPANY_STAMP(company.base.id, company.stampFileName)}
              onClick={() => {
                console.log('aa');
              }}
            />
          </Col>
          <Col xs={24} lg={12}>
            <Form
              layout="vertical"
              form={form}
              onFinish={companyEditOnFinish}
              initialValues={{
                name: company.name,
                representative: company.representative,
                corporationNo: company.corporationNo,
                businessNo: company.businessNo,
                addr1: company.addr1,
              }}
            >
              <Row gutter={[16, 16]}>
                <Col xs={24} lg={12}>
                  <FormItem label="법인명(업체명)" name="name" rules={[{ required: true, message: '법인명을 입력하세요.' }]}>
                    <Input />
                  </FormItem>
                </Col>
                <Col xs={24} lg={12}>
                  <FormItem label="대표자" name="representative" rules={[{ required: true, message: '대표자 이름을 입력하세요.' }]}>
                    <Input />
                  </FormItem>
                </Col>
                <Col xs={24} lg={24}>
                  <FormItem label="법인번호" name="corporationNo" rules={[{ required: true, message: '법인번호를 입력하세요.' }]}>
                    <Input />
                  </FormItem>
                </Col>
                <Col xs={24} lg={24}>
                  <FormItem label="사업자번호" name="businessNo" rules={[{ required: true, message: '사업자번호를 입력하세요.' }]}>
                    <Input />
                  </FormItem>
                </Col>
                <Col xs={24} lg={24}>
                  <FormItem label="사업장 소재지" name="addr1" rules={[{ required: true, message: '사업장 소재지를 입력하세요.' }]}>
                    <Input />
                  </FormItem>
                </Col>
                <Col xs={24} lg={24}>
                  <div className="flex justify-center items-center">
                    <Button type="dark" shape="round" htmlType="submit">
                      저장
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default ManageCompanyInfoPage;
